<template>
    <div class="about">
        <div class="about__inner">
            <div class="title-wrapper">
                <div class="section-symbol"></div>
                <p class="section-title is-lato">ABOUT</p>
                <p class="section-desc" v-html="$t('main.about.desc')"></p>
            </div>
            <p class="section-label is-lato">ABOUT</p>
            <router-link to="about" class="link">
                <div class="image" v-if="$resize && $mq.above(1024)">
                    <img src="@/assets/image/main/about-background.png" alt="">
                </div>
                <div class="image" v-else-if="$resize && $mq.above(320)">
                    <img src="@/assets/image/main/about-background-m.png" alt="">
                </div>
                <div class="box is-lato">
                    <div class="symbol"></div>
                    <p class="before">MAKE ONE <br class="under-tablet-break">WORLD,<br>E-COMMERCE <br class="under-tablet-break">PLATFORM</p>
                    <p class="after">MORE</p>
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: 'About'
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/mixin.scss';
@import '@/assets/style/main.scss';
@keyframes gradient {
    0% {background-position: 0% 50%;}
    50% {background-position: 100% 50%;}
    100% {background-position: 0% 50%;}
}
@include over-desktop {
    .about {
        height: 480px;
        &__inner {
            position: relative;
            width: 1200px;
            height: 100%;
            padding-top: 100px;
            margin: 0 auto;
            .section-title {
            margin-top: 12px;
            }
            .section-desc {
                margin-top: 12px;
            }
            .section-label {
                position: absolute;
                bottom: -40px;
                left: 0;
                font-weight: 700;
                font-size: 16px;
                color: #d2d2d2;
                letter-spacing: 16px;
                transform: rotate(-90deg);
                transform-origin: top left;

                &::before {
                    content: '';
                    display: block;
                    position: absolute;
                    top: 50%;
                    right: -100px;
                    width: 90px;
                    height: 1px;
                    background: #d2d2d2;
                    opacity: 0.3;
                }
            }
            .link {
                .image {
                    position: absolute;
                    overflow: hidden;
                    top: 128px;
                    right: 0;
                    width: 792px;
                    transition: opacity 250ms;
                    &::before {
                        content: '';
                        display: block;
                        position: absolute;
                        top: 0;
                        left: 0;
                        z-index: 1;
                        width: 100%;
                        height: 100%;
                        background: #000;
                        opacity: 0.2;
                        // transition: opacity 250ms;
                    }
                    img {
                        width: 100%;
                        height: auto;
                        transform: scale(1);
                        transition: transform 250ms;
                    }
                }
                .box {
                    @include gradient-45;
                    position: absolute;
                    right: 620px;
                    bottom: -30px;
                    width: 285px;
                    height: 190px;
                    padding: 30px 35px;
                    background-size: 800%;
                    color: #fff;
                    font-size: 16px;
                    line-height: 22px;
                    letter-spacing: -1px;
                    animation: gradient 18s infinite;
                    .symbol {
                        width: 40px;
                        height: 50px;
                        background: #fff;
                        background: url(../../assets/image/logo/symbol.svg) no-repeat center;
                        background-size: 100% auto;
                        opacity: 0.9;
                    }
                    .before,
                    .after {
                        position: absolute;
                        bottom: 30px;
                        left: 35px;
                        transition: opacity 250ms;
                    }
                    .before {
                        opacity: 1;
                    }
                    .after {
                        opacity: 0;
                    }
                }
                &:hover {
                    .image {
                        // &::before {
                        //     opacity: 0.2;
                        // }
                        img {
                            transform: scale(1.1);
                        }
                    }
                    .box {
                        .before {
                            opacity: 0;
                        }
                        .after {
                            opacity: 1;
                        }
                    }
                }
            }
        }
    }
    .section01 > .about {
        .title-wrapper {
            opacity: 0;
            transform: translateY(-40px);
            transition: opacity 1000ms, transform 1000ms;
        }
        .section-label {
            opacity: 0;
            transform: rotate(-90deg) translateX(100px);
            transition: opacity 1000ms 750ms, transform 1000ms 750ms;
        }
        .link > .image {
            opacity: 0;
            transform: translateY(100px);
            transition: opacity 500ms 250ms, transform 500ms 250ms;
        }
        .link > .box {
            opacity: 0;
            transform: translateX(40px);
            transition: opacity 500ms 500ms, transform 500ms 500ms;
        }
    }
    .section01.is-active > .about {
        .title-wrapper {
            opacity: 1;
            transform: translateY(0);
        }
        .section-label {
            opacity: 1;
            transform: rotate(-90deg) translateX(0);
        }
        .link .image {
            opacity: 1;
            transform: translateY(0);
        }
        .link .box {
            opacity: 1;
            transform: translateX(0);
        }
    }
}
@include desktop-small {
    .about {
        &__inner {
            width: 1024px;
            padding: 100px 28px 0;
            .section-label {
                left: 28px;
            }
            .link {
                .image {
                    right: 28px;
                    width: 640px;
                }
                .box {
                    right: 500px;
                }
            }
        }
    }
}
@include under-tablet {
    .about {
        overflow: hidden;
        height: initial;
        padding: 14vw 0;
        &__inner {
            width: 100%;
            padding: 0 28px;
            .section-label {
                display: none;
            }
            .section-title {
                margin-top: 3.4vw;
            }
            .section-desc {
                margin-top: 3.4vw;
            }
            .link {
                display: block;
                margin-top: 8vw;
                text-align: right;
                .image {
                    display: inline-block;
                    position: relative;
                    overflow: hidden;
                    width: 77vw;

                    &::before {
                        content: '';
                        display: block;
                        position: absolute;
                        top: 0;
                        left: 0;
                        z-index: 1;
                        width: 100%;
                        height: 100%;
                        background: #000;
                        opacity: 0.2;
                        // transform: opacity 250ms;
                    }
                    img {
                        width: 100%;
                        height: auto;
                        transform: scale(1);
                        transition: transform 250ms;
                    }
                }
                .box {
                    @include gradient-45;
                    position: relative;
                    z-index: 1;
                    margin-top: -32vw;
                    width: 38vw;
                    height: 38vw;
                    padding: 5.4vw;
                    background-size: 800%;
                    color: #fff;
                    font-size: 3.2vw;
                    line-height: 3.8vw;
                    letter-spacing: -1px;
                    text-align: left;
                    animation: gradient 18s infinite;
                    .symbol {
                        width: 7.2vw;
                        height: 9vw;
                        background: #fff;
                        background: url(../../assets/image/logo/symbol.svg) no-repeat center;
                        background-size: 100% auto;
                        opacity: 0.9;
                    }
                    .before,
                    .after {
                        margin-top: 2vw;
                        transform: opacity 250ms;
                    }
                    .before {
                        opacity: 1;
                    }
                    .after {
                        position: absolute;
                        bottom: 5.4vw;
                        left: 5.4vw;
                        opacity: 0;
                    }
                }
                &:hover {
                    .image {
                        &::before {
                            opacity: 0.2;
                        }
                        img {
                            transform: scale(1.1);
                        }
                    }
                    .box {
                        .before {
                            opacity: 0;
                        }
                        .after {
                            opacity: 1;
                        }
                    }
                }
            }
        }
    }
    .section01 > .about {
        .title-wrapper {
            opacity: 0;
            transform: translateY(4vh);
            transition: opacity 1000ms, transform 1000ms;
        }
        .link > .image {
            opacity: 0;
            transform: translateY(-2vh);
            transition: opacity 1000ms 250ms, transform 1000ms 250ms;
        }
        .link > .box {
            opacity: 0;
            transform: translateX(4vw);
            transition: opacity 1000ms 500ms, transform 1000ms 500ms;
        }
    }
    .section01.is-active > .about {
        .title-wrapper {
            opacity: 1;
            transform: translateY(0);
        }
        .link .image {
            opacity: 1;
            transform: translateY(0);
        }
        .link .box {
            opacity: 1;
            transform: translateX(0);
        }
    }
}
@include mobile {
    .about {
        &__inner {
            padding: 0 20px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/main/About.vue